import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 14.82" {...props}><path data-name="Path 624" d="M24 2.82l-12 12-12-12L2.82 0 12 9.16 21.18 0z" fill="#6c7778" /></svg>);